import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import VerifiedIcon from '@mui/icons-material/Verified';
import LayersIcon from '@mui/icons-material/Layers';
import { BRAND, GRADIENT } from '../theme';

// HeroCard
//
// Top-of-page hero. Title + subtitle + three trust pills. Pure presentational
// — no wallet / API dependencies — so it renders identically on first paint.

export default function HeroCard() {
  return (
    <Box
      sx={{
        position: 'relative',
        textAlign: 'center',
        pb: { xs: 4, md: 5 },
        pt: { xs: 1, md: 2 },
      }}
    >
      <Chip
        icon={<BoltIcon sx={{ fontSize: 16 }} />}
        label="Live · 5 bps · ~2 min"
        size="small"
        sx={{
          mb: 2,
          background: `linear-gradient(90deg, ${BRAND.violet}33, ${BRAND.cyan}33)`,
          border: `1px solid ${BRAND.violet}55`,
          color: BRAND.textPrimary,
          fontWeight: 600,
        }}
      />
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: '2.1rem', sm: '2.6rem', md: '3.2rem' },
          fontWeight: 800,
          lineHeight: 1.1,
          background: GRADIENT,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          mb: 1.5,
          letterSpacing: '-0.025em',
        }}
      >
        Move kStables between chains
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: '1rem', md: '1.1rem' },
          color: BRAND.textSecondary,
          maxWidth: 640,
          mx: 'auto',
          mb: 3,
          lineHeight: 1.5,
        }}
      >
        Burn on source, mint on destination. Same coin, same accounting.
        Minutes, not days.
      </Typography>
      <Stack
        direction="row"
        spacing={{ xs: 1, sm: 2 }}
        justifyContent="center"
        flexWrap="wrap"
        sx={{ gap: 1 }}
      >
        <TrustPill icon={<VerifiedIcon sx={{ fontSize: 14 }} />} label="1:1, wei-exact" />
        <TrustPill icon={<LayersIcon sx={{ fontSize: 14 }} />} label="Collateral stays on source" />
        <TrustPill icon={<BoltIcon sx={{ fontSize: 14 }} />} label="Same coin identity" />
      </Stack>
    </Box>
  );
}

function TrustPill({ icon, label }) {
  return (
    <Chip
      icon={icon}
      label={label}
      size="small"
      sx={{
        backgroundColor: 'rgba(255,255,255,0.04)',
        border: `1px solid ${BRAND.border}`,
        color: BRAND.textSecondary,
        '& .MuiChip-icon': { color: BRAND.cyan, ml: 0.5 },
      }}
    />
  );
}
